module.exports = __webpack_public_path__ + "img/googleImg.76f84058.png";